import React, { useState, useEffect, useRef } from "react";
import "./KeyList.scss";
const musicKey = [
  "Ab",
  "Abm",
  "A",
  "Am",
  "Bb",
  "Bbm",
  "B",
  "Bm",
  "C",
  "Cm",
  "C#",
  "C#m",
  "D",
  "Dm",
  "Eb",
  "Ebm",
  "E",
  "Em",
  "F",
  "Fm",
  "F#",
  "F#m",
  "G",
  "Gm"
];

const KeyList = ({ changeKey }: any) => {
  return (
    <div className="key-select">
      {musicKey.map((key, i) => (
        <p className="key-select-item" key={i} onClick={() => changeKey(key)}>
          {key}
        </p>
      ))}
    </div>
  );
};
export default KeyList;
